import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';

export const constants = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  ID_TOKEN: 'idToken',
  EXPIRY_TIME: 'expiryDateTime',
};

export const EXPIRY_BUFFER_SECONDS: number = 60;

export const isTokenExpired = (
  currentTime?: string | null,
  expiryTime?: string | null,
  bufferSeconds: number = EXPIRY_BUFFER_SECONDS
): boolean => {
  if (expiryTime === null || expiryTime === undefined) {
    return true;
  }

  const expiry = dayjs(expiryTime);
  if (!expiry.isValid()) {
    return true;
  }

  const now = currentTime ? dayjs(currentTime) : dayjs();
  const threshold = expiry.subtract(bufferSeconds, 'second');

  return now.isSame(threshold) || now.isAfter(threshold);
};


export const getAuthItem = (key: any): any => window.localStorage.getItem(key);
export const setAuthItem = (key: any, value: any): any => window.localStorage.setItem(key, value);
export const deleteAuthItem = (key: any): any => window.localStorage.removeItem(key);

export const saveToken = (data: any): any => {
  setAuthItem(constants.ACCESS_TOKEN, data.access_token);
  if (data.refresh_token) {
    setAuthItem(constants.REFRESH_TOKEN, data.refresh_token);
  }
  setAuthItem(constants.ID_TOKEN, data.id_token);
  
  const expiryTime = dayjs().add(data.expires_in, 'second').toISOString();
  setAuthItem(constants.EXPIRY_TIME, expiryTime);
};

export const getIdTokenValues = (key: string) => {
  const idToken = getAuthItem(constants.ID_TOKEN);
  if(!idToken) return;
  const idTokenValues = jwtDecode(idToken) as any;
  return idTokenValues?.[key];
};export const clearAllTokens = (): void => {
  deleteAuthItem(constants.ACCESS_TOKEN);
  deleteAuthItem(constants.REFRESH_TOKEN);
  deleteAuthItem(constants.ID_TOKEN);
  deleteAuthItem(constants.EXPIRY_TIME);
};

